/**
 * Feature flags do frontend.
 * Campanhas: gate de produto via API (`/me/permissions` → features.campaigns).
 * Anúncios (Meta/Google): features.paidAds — independente de campanhas.
 * O build flag FEATURE_CAMPAIGNS_ENABLED abaixo é legado e não controla menu.
 * Repasses (passagens): defina REACT_APP_FEATURE_PASSAGENS_REPASSES=1 no build para liberar.
 * Console plataforma: dashboard consolidado / conversa interna — off até liberação;
 *   REACT_APP_FEATURE_PLATFORM_CONSOLIDATED_DASHBOARD=1 e
 *   REACT_APP_FEATURE_PLATFORM_INTERNAL_CHAT=1 para reativar.
 */
function envFlag(name, defaultValue = false) {
  const raw = typeof process !== "undefined" ? process.env?.[name] : undefined;
  if (raw === "1" || raw === "true") return true;
  if (raw === "0" || raw === "false") return false;
  return defaultValue;
}

/**
 * @deprecated Preferir features.campaigns de /me/permissions.
 * Mantido só para imports legados; não usa como gate de UI.
 */
export const FEATURE_CAMPAIGNS_ENABLED = false;

/** Repasses XPay (venda de passagens) — oculto até liberação futura. */
export const FEATURE_PASSAGENS_REPASSES_ENABLED = envFlag("REACT_APP_FEATURE_PASSAGENS_REPASSES", false);

/** Dashboard consolidado no console da plataforma — oculto temporariamente. */
export const FEATURE_PLATFORM_CONSOLIDATED_DASHBOARD_ENABLED = envFlag(
  "REACT_APP_FEATURE_PLATFORM_CONSOLIDATED_DASHBOARD",
  false
);

/** Conversa interna no console da plataforma — oculto temporariamente. */
export const FEATURE_PLATFORM_INTERNAL_CHAT_ENABLED = envFlag(
  "REACT_APP_FEATURE_PLATFORM_INTERNAL_CHAT",
  false
);

/** Recursos ocultos quando a feature correspondente da API está off. */
export const CAMPAIGNS_HIDDEN_RESOURCE_KEYS = new Set(["campaigns"]);
export const PAID_ADS_HIDDEN_RESOURCE_KEYS = new Set(["paid_ads"]);
